import {
  Alert,
  Badge,
  Box,
  Chip,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  LinearProgress,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  Tab,
  Tabs,
  TextField,
  Typography,
  Checkbox,
  OutlinedInput,
  Tooltip,
  Modal,
} from "@mui/material";
import { Search, Clear, Print, Article } from "@mui/icons-material";
import { useTheme } from "@mui/system";
import useStyles from "./styles";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import "dayjs/locale/pt-br";
import DatagridComponent from "../../../components/datagridComponent";
import TopBarFilter from "../../../components/topBarFilter";
import { useOutletContext } from "react-router-dom";
import CardDataComponent from "../../../components/overview/cardDataComponent";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { useGridApiRef } from "@mui/x-data-grid";
import generatePdfTable from "../../../utils/generatePdfAutoTable";

import TabCPE from "./tabs/tabCpe";
import TabOnu from "./tabs/tabOnu";
import TabsErp from "./components/tabsErp";
import TabAtendimentos from "./components/tabAtendimentos";
import ClienteComTipo from "./components/clienteComTipo";
import TabTrafego from "./components/tabTrafego";
import TabPotencia from "./components/tabPotencia";
import TicketModalContent from "../../../components/tickets/detailsTicketComponent";
import TicketModalContentIxc from "../../../components/tickets/detailsTicketIxcComponent";
import InternoModalConfirmacaoSaida from "../../../components/modalSaindoDaPagina";

dayjs.extend(localizedFormat);
dayjs.locale("pt-br");

export default function ResumoPercentil() {
  const theme = useTheme();
  const styles = useStyles(theme);

  const [selectedMonth, setSelectedMonth] = useState("actual");
  const [initial_date, setInitial_date] = useState(dayjs().startOf("month"));
  const [final_date, setFinal_date] = useState(dayjs());
  const [snackbar, setSnackbar] = useState(null);
  const [search, setSearch] = useState(null);
  const [windowWith, setWindowWith] = useState(window.innerWidth);
  const [openFilter, setOpenFilter] = useState(false);
  const [statusFilter, setStatusFilter] = useState([]);
  const [statusFilterAtendimento, setStatusFilterAtendimento] = useState([]);

  // Controle de requisições globais
  const [loading, setLoading] = useState(false);
  const [loadingOnu, setLoadingOnu] = useState(false);
  const [loadingNewClients, setLoadingNewClients] = useState(false);
  const [loadingAccess, setLoadingAccess] = useState(false);
  const { controllerDashboard, setControllerDashboard } = useOutletContext();

  // Armazenamento de resultados globais
  const [rankingPercentil, setRankingPercentil] = useState([]);
  const [recurringAlerts, setRecurringAlerts] = useState([]);
  const [resumoOnu, setResumoOnu] = useState([]);
  const [loadingReccurringAlerts, setLoadingRecurringAlerts] = useState(false);
  const [newClients, setNewClients] = useState(null);
  const [access, setAccess] = useState(null);
  const [contratosStatus, setContratosStatus] = useState(null);
  const [loadingContratosStatus, setLoadingContratosStatus] = useState(false);

  const mesAtual = dayjs().format("MMMM");
  const mesPassado = dayjs().subtract(1, "month").format("MMMM");

  const [searchAlert, setSearchAlert] = useState("");
  const [filteredAlerts, setFilteredAlerts] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [filteredRowsOnu, setFilteredRowsOnu] = useState([]);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const apiRefAlerts = useGridApiRef();
  const [tabValue, setTabValue] = useState(0);
  // Aba do painel direito (0 = Atendimentos, 1 = detalhe: Potência/Tráfego).
  // Vive aqui para persistir ao alternar entre CPE e ONU.
  const [viewDireita, setViewDireita] = useState(0);
  // Linha selecionada em cada datagrid (esquerda). Elevadas para cá porque o
  // detalhe (Tráfego/Potência) do painel direito as consome.
  const [selectedRowCpe, setSelectedRowCpe] = useState(null);
  const [selectedRowOnu, setSelectedRowOnu] = useState(null);
  const [loadingAtendimentos, setLoadingAtendimentos] = useState(false);
  const [rowsAtendimentos, setRowsAtendimentos] = useState([]);
  const [openModal, setOpenModal] = useState(false);

  // Detalhes do ticket / modal de atendimento
  const [ticketDetails, setTicketDetails] = useState(null);
  const [loadingTicketDetails, setLoadingTicketDetails] = useState(false);
  const [itensPublic, setItensPublic] = useState({
    mensagens: [],
    anexos: [],
    rfo: [],
  });
  const [ticketTabValue, setTicketTabValue] = useState(0);
  const [isEditTicket, setIsEditTicket] = useState(false);
  const [isFinishTicket, setIsFinishTicket] = useState(false);
  const [isEditOs, setIsEditOs] = useState(false);
  const [isNewOs, setIsNewOs] = useState(false);
  const [confirmacaoSaidaPagina, setConfirmacaoSaidaPagina] = useState(false);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleTicketTabChange = (event, newValue) => {
    setTicketTabValue(newValue);
  };

  const handleCloseSearch = () => {
    setConfirmacaoSaidaPagina(false);
    setIsEditTicket(false);
    setIsFinishTicket(false);
    setIsEditOs(false);
    setIsNewOs(false);
    setTicketDetails(null);
    setOpenModal(false);
    setTicketTabValue(0);
  };

  const handleCancelNavigation = () => {
    setConfirmacaoSaidaPagina(false);
  };

  const chipStatusAtendimento = (status) => {
    switch (status) {
      case "Pendente":
        return (
          <Tooltip title={"Pendente"}>
            <Chip size="small" sx={styles.chipPendente} label={"Pendente"} />
          </Tooltip>
        );
      case "Aguardando Análise":
        return (
          <Tooltip title={"Aguardando Análise"}>
            <Chip size="small" sx={styles.chipAndamento} label={"Aguardando"} />
          </Tooltip>
        );
      case "Resolvido":
        return (
          <Tooltip title={"Resolvido"}>
            <Chip size="small" sx={styles.chipResolvido} label={"Resolvido"} />
          </Tooltip>
        );
      case "Em progresso":
        return (
          <Tooltip title={"Em progresso"}>
            <Chip
              size="small"
              sx={styles.chipAndamento}
              label={"Em progresso"}
            />
          </Tooltip>
        );
      case "Solucionado":
        return (
          <Tooltip title={"Solucionado"}>
            <Chip
              size="small"
              sx={styles.chipResolvido}
              label={"Solucionado"}
            />
          </Tooltip>
        );
      case "Novo":
        return (
          <Tooltip title={"Novo"}>
            <Chip size="small" sx={styles.chipNovo} label={"Novo"} />
          </Tooltip>
        );
      default:
        return (
          <Tooltip title={"Cancelado"}>
            <Chip size="small" sx={styles.chipDefault} label="Cancelado" />
          </Tooltip>
        );
    }
  };

  // Mesmo chip de status usado na tabela de ONU (tabOnu.js), por rótulo
  const chipStatusOnu = (label) => {
    const colorByLabel = {
      Crítica: "critical",
      Atenção: "high",
      Ok: "success",
      "N/A": "neutral",
    };
    const colorKey = colorByLabel[label] || "neutral";
    const isNeutral = colorKey === "neutral";

    return (
      <Chip
        label={label}
        sx={{
          backgroundColor: isNeutral
            ? "transparent"
            : theme.palette.chip.background[colorKey],
          color: isNeutral
            ? theme.palette.text.disabled
            : theme.palette.chip.colorText[colorKey],
          border: "0.6px solid",
          borderColor: isNeutral
            ? theme.palette.text.disabled
            : theme.palette.chip.colorText[colorKey],
          borderRadius: "10px",
          height: "20px",
          width: "70px",
        }}
        size="small"
      />
    );
  };

  const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP || "";
  const labelErp =
    erp === "HUBSOFT"
      ? "Serviço"
      : erp === "VOALLE"
        ? "Contrato"
        : erp === "IXC"
          ? "Contrato"
          : erp === "VERO"
            ? "Contrato"
            : "Serviço";

  const labelTabsErp = {
    descricao:
      erp === "HUBSOFT"
        ? "Descrição"
        : erp === "VOALLE"
          ? "Geral"
          : "Descrição",
    mensagens:
      erp === "HUBSOFT"
        ? "Mensagens"
        : erp === "VOALLE"
          ? "Histórico"
          : "Mensagens",
  };

  // Carregamento dos dados iniciais
  useEffect(() => {
    getResumo();
    getResumoOnu();
    getRecurringAlerts();
    getAtendimentos();
    getContratosStatus();
    const handleResize = () => setWindowWith(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setInitial_date(
      selectedMonth === "actual"
        ? dayjs().startOf("month")
        : dayjs().subtract(1, "month").startOf("month"),
    );
    setFinal_date(
      selectedMonth === "actual"
        ? dayjs()
        : dayjs().subtract(1, "month").endOf("month"),
    );
  }, [selectedMonth]);

  useEffect(() => {
    if (!initial_date) return;
    getRecurringAlerts();
  }, [initial_date]);
  const activeTableData = tabValue === 0 ? rankingPercentil : resumoOnu;
  const activeTableLoading = tabValue === 0 ? loading : loading;
  const formatUptime = (totalSeconds) => {
    if (!totalSeconds) return "00:00:00:00";

    const seconds = parseInt(totalSeconds, 10);

    if (isNaN(seconds)) return totalSeconds;

    if (seconds <= 0) return "00:00:00:00";

    const dias = Math.floor(seconds / (3600 * 24));
    const horas = Math.floor((seconds % (3600 * 24)) / 3600);
    const minutos = Math.floor((seconds % 3600) / 60);
    const seg = Math.floor(seconds % 60);

    const pad = (num) => String(num).padStart(2, "0");

    return `${pad(dias)}d:${pad(horas)}h:${pad(minutos)}m:${pad(seg)}s`;
  };
  // Funções de API de dados globais (mantidas)
  const getResumo = async () => {
    if (controllerDashboard) controllerDashboard.abort();
    const newController = new AbortController();
    const signal = newController.signal;
    setControllerDashboard(newController);
    try {
      setLoading(true);
      const promises = [
        api.get("/interno/findMany/resume", signal),
        getNewClients(signal),
        getAccess(signal),
      ];
      const responses = await Promise.all(promises);
      setRankingPercentil(responses[0]?.data || []);
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${error?.response?.data?.error || "Não foi possível se buscar o resumo"}`,
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const getResumoOnu = async () => {
    if (controllerDashboard) controllerDashboard.abort();
    const newController = new AbortController();
    const signal = newController.signal;
    setControllerDashboard(newController);
    try {
      setLoadingOnu(true);
      const response = await api.get("/interno/findMany/resumeOnu", signal);

      setResumoOnu(response?.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingOnu(false);
    }
  };

  const getRecurringAlerts = async () => {
    try {
      setLoadingRecurringAlerts(true);
      const response = await api.post("/zabbix/items/recurringAlerts", {
        initial_date: initial_date,
        final_date: final_date,
      });
      setRecurringAlerts(response?.data || []);
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.response?.data?.error ||
          "Não foi possível obter alertas recorrentes"
        } `,
        severity: "error",
      });
    } finally {
      setLoadingRecurringAlerts(false);
    }
  };

  const getNewClients = async (signal) => {
    try {
      setLoadingNewClients(true);
      const response = await api.get(
        "/interno/findMany/countNewCustomers",
        {},
        { signal },
      );
      setNewClients(response?.data || null);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingNewClients(false);
    }
  };

  const getAccess = async (signal) => {
    try {
      setLoadingAccess(true);
      const response = await api.get(
        "/interno/findMany/clientUsagePercent",
        {},
        { signal },
      );
      setAccess(response?.data || null);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingAccess(false);
    }
  };

  const getContratosStatus = async (signal) => {
    try {
      setLoadingContratosStatus(true);
      const response = await api.get(
        "/find/countContratosStatus",
        {},
        { signal },
      );
      setContratosStatus(response?.data || null);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingContratosStatus(false);
    }
  };

  const getAtendimentos = async (signal) => {
    try {
      setLoadingAtendimentos(true);
      const response = await api.post(
        "/find/getAtendimentosDash",
        { initial_date, final_date },
        { signal },
      );

      const data = response?.data?.atendimentos || [];
      const formatted = data?.map((item, index) => ({
        id: item?.id_atendimento,
        protocolo: item?.protocolo,
        serviceID: item?.servico?.id_cliente_servico,
        status: item?.status,
        dataAbertura: item?.data_cadastro || null,
        dataFechamento: item?.data_fechamento || null,
        cliente: item?.cliente?.nome || "",
        // Vem da coluna tipoCliente do nosso banco, casada pelo id do ERP no
        // backend. É null quando o cliente não tem contraparte local.
        tipoCliente: item?.cliente?.tipoCliente ?? null,
        tecnico: item?.usuario_fechamento,
        descricao: item?.descricao_abertura,
        quantidadeOS: item?.os,
      }));
      setRowsAtendimentos(formatted);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingAtendimentos(false);
    }
  };

  // Filtra os dados da tabela de CPE e Alertas (mantidos no pai pois afetam dados gerais)
  useEffect(() => {
    if (search) {
      setFilteredRows(
        rankingPercentil?.filter((row, index) => {
          row.numero = index;
          const res = row?.percentile?.find((th) =>
            dayjs(initial_date)?.isSame(dayjs(th?.refferenceMonth), "month"),
          );
          return (
            row?.nome?.toLowerCase()?.includes(search?.toLowerCase()) ||
            row?.host?.toLowerCase()?.includes(search?.toLowerCase()) ||
            (row?.availability === "1" &&
              "Up!"?.toLowerCase()?.includes(search?.toLowerCase())) ||
            (row?.availability === "0" &&
              "Down!"?.toLowerCase()?.includes(search?.toLowerCase())) ||
            formatUptime(row?.uptime)
              ?.toLowerCase()
              ?.includes(search?.toLowerCase()) ||
            (!!res ? formatBytes(res?.percentilConsumption) : "")
              ?.toLowerCase()
              ?.includes(search?.toLowerCase())
          );
        }),
      );
    } else {
      setFilteredRows(rankingPercentil);
    }
  }, [search, rankingPercentil]);

  useEffect(() => {
    let filtered = resumoOnu || [];

    if (statusFilter && statusFilter.length > 0) {
      filtered = filtered.filter((row) => {
        const raw = row?.receivedPower;
        const p = parseFloat(raw);
        const isNA = raw === null || raw === undefined || isNaN(p);

        let status = "";
        if (isNA) status = "N/A";
        else if (p <= -27) status = "Crítica";
        else if (p <= -25) status = "Atenção";
        else status = "Ok";

        return statusFilter.includes(status);
      });
    }

    if (search) {
      setFilteredRowsOnu(
        filtered?.filter((row, index) => {
          row.numero = index;
          const res = row?.percentile?.find((th) =>
            dayjs(initial_date)?.isSame(dayjs(th?.refferenceMonth), "month"),
          );
          return (
            row?.nome?.toLowerCase()?.includes(search?.toLowerCase()) ||
            row?.onuItem?.toLowerCase()?.includes(search?.toLowerCase()) ||
            row?.host?.toLowerCase()?.includes(search?.toLowerCase()) ||
            (row?.availability === "1" &&
              "Up!"?.toLowerCase()?.includes(search?.toLowerCase())) ||
            (row?.availability === "0" &&
              "Down!"?.toLowerCase()?.includes(search?.toLowerCase())) ||
            (!!res ? formatBytes(res?.percentilConsumption) : "")
              ?.toLowerCase()
              ?.includes(search?.toLowerCase())
          );
        }),
      );
    } else {
      setFilteredRowsOnu(filtered);
    }
  }, [search, resumoOnu, statusFilter]);

  useEffect(() => {
    if (searchAlert) {
      setFilteredAlerts(
        recurringAlerts?.filter((alert) => {
          return (
            alert?.nome
              ?.toLowerCase()
              ?.includes(searchAlert?.toLowerCase()) ||
            alert?.hosts?.[0]?.host
              ?.toLowerCase()
              ?.includes(searchAlert?.toLowerCase()) ||
            alert?.interface
              ?.toLowerCase()
              ?.includes(searchAlert?.toLowerCase()) ||
            alert?.description
              ?.toLowerCase()
              ?.includes(searchAlert?.toLowerCase()) ||
            alert?.occurrences?.toString()?.includes(searchAlert)
          );
        }),
      );
    } else {
      setFilteredAlerts(recurringAlerts);
    }
  }, [searchAlert, recurringAlerts]);

  // Cards, Actions e Selectors
  const cardData = {
    up:
      tabValue !== 0
        ? activeTableData?.filter((row) => {
            const p = parseFloat(row?.receivedPower);
            return !isNaN(p) && p > -27;
          })?.length
        : activeTableData?.filter(
            (row) => row?.availability === "1" || row?.availability === 1,
          )?.length,
    down:
      tabValue !== 0
        ? activeTableData?.filter((row) => {
            const p = parseFloat(row?.receivedPower);
            return !isNaN(p) && p <= -27;
          })?.length
        : activeTableData?.filter(
            (row) => row?.availability === "0" || !row?.availability,
          )?.length,
    alerts: Array.isArray(recurringAlerts) && recurringAlerts?.length,
    uniqueAccess: access?.[selectedMonth]
      ? `${access?.[selectedMonth]} %`
      : "Não encontrado",
    newClient: newClients?.[selectedMonth] || "Não encontrado",
    atendimentos: rowsAtendimentos?.length,
    atendimentosAbertos: Array.isArray(rowsAtendimentos)
      ? rowsAtendimentos.filter((row) => !row?.dataFechamento).length
      : 0,
    contratosExpirados: contratosStatus?.["Expirado"] || 0,
  };

  // Calcula o percentual de uma parte em relação ao total (arredondado, seguro contra divisão por zero)
  const percentDoTotal = (parte, total) =>
    total > 0 ? `${Math.round((Number(parte) / total) * 100)}% do total` : null;

  const totalAtendimentos = cardData.atendimentos || 0;
  const totalHosts = (cardData.up || 0) + (cardData.down || 0);
  const totalContratos = contratosStatus?.total || 0;

  const cardParams = [
    {
      key: "up",
      name: "Up",
      typeIcon: 4,
      color: "statusUp",
      loading: loading,
      helperText: percentDoTotal(cardData.up, totalHosts),
      info: {
        titulo: "Hosts Up",
        descricao:
          "Quantidade de hosts monitorados que estão online (respondendo ao monitoramento) no momento. O texto abaixo mostra o percentual em relação ao total de hosts.",
        comoLer: [
          "Quanto maior, melhor — indica a disponibilidade da rede agora.",
          "O percentual é calculado sobre o total de hosts (Up + Down).",
        ],
      },
    },
    {
      key: "down",
      name: "Down",
      typeIcon: 4,
      color: "statusDown",
      loading: loading,
      helperText: percentDoTotal(cardData.down, totalHosts),
      info: {
        titulo: "Hosts Down",
        descricao:
          "Quantidade de hosts monitorados que estão offline (sem resposta ao monitoramento) no momento. O texto abaixo mostra o percentual em relação ao total de hosts.",
        comoLer: [
          "Quanto menor, melhor — cada host Down é um possível cliente sem conexão.",
          "Picos podem indicar falha de rota, energia ou equipamento.",
        ],
      },
    },
    {
      key: "atendimentos",
      name: "Total de Atendimentos ",
      typeIcon: 5,
      color: "inputData",
      loading: loadingAtendimentos,
      helperText: `${totalAtendimentos - cardData.atendimentosAbertos} finalizados`,
      info: {
        titulo: "Total de Atendimentos",
        descricao:
          "Total de atendimentos (chamados/OS) no período filtrado, somando os abertos e os finalizados. O texto abaixo mostra quantos já foram finalizados.",
        comoLer: [
          "É o volume total de demanda no período selecionado.",
          "Finalizados = Total − Atendimentos Abertos.",
        ],
      },
    },
    {
      key: "atendimentosAbertos",
      name: "Atendimentos Abertos",
      typeIcon: 5,
      color: "speeData",
      loading: loadingAtendimentos,
      helperText: percentDoTotal(
        cardData.atendimentosAbertos,
        totalAtendimentos,
      ),
      info: {
        titulo: "Atendimentos Abertos",
        descricao:
          "Atendimentos ainda em aberto (não finalizados) no período filtrado. O texto abaixo mostra o percentual em relação ao total de atendimentos.",
        comoLer: [
          "Representa a fila de trabalho pendente da equipe.",
          "Percentual alto sobre o total pode indicar acúmulo/gargalo.",
        ],
      },
    },
    {
      key: "alerts",
      name: "Alertas",
      typeIcon: 7,
      color: "outputData",
      loading: loadingReccurringAlerts,
      helperText: Array.isArray(recurringAlerts)
        ? `${recurringAlerts.reduce(
            (acc, alert) => acc + (Number(alert?.occurrences) || 0),
            0,
          )} ocorrências`
        : null,
      info: {
        titulo: "Alertas",
        descricao:
          "Quantidade de alertas recorrentes detectados no monitoramento. O texto abaixo soma o total de ocorrências desses alertas.",
        comoLer: [
          "Um mesmo alerta pode ter várias ocorrências (repetições).",
          "Alertas recorrentes apontam problemas crônicos a investigar.",
        ],
      },
    },
    {
      key: "contratosExpirados",
      name: "Contratos Expirados",
      typeIcon: 16,
      color: "statusDown",
      loading: loadingContratosStatus,
      helperText: percentDoTotal(cardData.contratosExpirados, totalContratos),
      info: {
        titulo: "Contratos Expirados",
        descricao:
          "Quantidade de contratos com data de vigência já expirada. O texto abaixo mostra o percentual em relação ao total de contratos.",
        comoLer: [
          "Indicam clientes que precisam de renovação/regularização.",
          "Percentual sobre o total ajuda a dimensionar o impacto na base.",
        ],
      },
    },
  ];

  const actions = [
    {
      icon: <FilterAltOutlinedIcon />,
      name: "Filtro",
      onClick: () => setOpenFilter(true),
    },
  ];

  // Opções do filtro de status do atendimento, derivadas dos dados carregados
  const statusAtendimentoOptions = Array.from(
    new Set(
      (rowsAtendimentos || [])
        .map((row) => row?.status)
        .filter((status) => !!status),
    ),
  ).sort();

  // Atendimentos exibidos no painel, aplicando o filtro de status selecionado
  const filteredAtendimentos = (rowsAtendimentos || []).filter(
    (row) =>
      statusFilterAtendimento.length === 0 ||
      statusFilterAtendimento.includes(row?.status),
  );

  const selectorComponentLeft = (
    <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexGrow: 1 }}>
      <TextField
        variant="outlined"
        label="Buscar"
        placeholder="Cliente, Host, Etc..."
        value={search}
        size="small"
        sx={styles.textFieldSearch}
        onChange={(e) => setSearch(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
          endAdornment: search ? (
            <InputAdornment position="end">
              <IconButton onClick={() => setSearch("")} edge="end">
                <Clear />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
      />
      <FormControl size="small" sx={{ minWidth: 210 }}>
        <InputLabel id="status-atendimento-label">
          Status do Atendimento
        </InputLabel>
        <Select
          labelId="status-atendimento-label"
          multiple
          value={statusFilterAtendimento}
          onChange={(e) => setStatusFilterAtendimento(e.target.value)}
          input={<OutlinedInput label="Status do Atendimento" />}
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {selected.map((name) => (
                <Box key={name}>{chipStatusAtendimento(name)}</Box>
              ))}
            </Box>
          )}
        >
          {statusAtendimentoOptions.map((name) => (
            <MenuItem key={name} value={name}>
              <Checkbox checked={statusFilterAtendimento.indexOf(name) > -1} />
              {chipStatusAtendimento(name)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {tabValue === 1 && (
        <FormControl size="small" sx={{ minWidth: 210 }}>
          <InputLabel id="status-onu-label">Status da ONU</InputLabel>
          <Select
            labelId="status-onu-label"
            multiple
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            input={<OutlinedInput label="Status da ONU" />}
            renderValue={(selected) => (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {selected.map((name) => (
                  <Box key={name}>{chipStatusOnu(name)}</Box>
                ))}
              </Box>
            )}
          >
            {["Ok", "Atenção", "Crítica", "N/A"].map((name) => (
              <MenuItem key={name} value={name}>
                <Checkbox checked={statusFilter.indexOf(name) > -1} />
                {chipStatusOnu(name)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </Box>
  );

  const selectorComponentRight = (
    <FormControl sx={styles.formControl} size="small">
      <Select
        value={selectedMonth || ""}
        onChange={(e) => setSelectedMonth(e?.target?.value)}
      >
        <MenuItem value={"actual"}>
          {mesAtual[0]?.toUpperCase() + mesAtual?.substring(1)}
        </MenuItem>
        <MenuItem value={"last"}>
          {mesPassado[0]?.toUpperCase() + mesPassado?.substring(1)}
        </MenuItem>
      </Select>
    </FormControl>
  );

  const recurringAlertsColumns = [
    { editable: false, field: "id", headerName: "ID", hide: true },
    {
      field: "nome",
      headerName: "Cliente",
      flex: 1,
      renderCell: (params) => (
        <ClienteComTipo
          nome={params?.row?.nome || ""}
          tipoCliente={params?.row?.tipoCliente}
        />
      ),
    },
    {
      field: "hosts",
      headerName: "Host",
      flex: 0.9,
      valueGetter: (value, row) => {
        const linha = row || (value && value.row) || {};

        if (Array.isArray(linha.hosts) && linha.hosts.length > 0) {
          return linha.hosts[0]?.host || "";
        }

        if (linha.host) {
          return linha.host;
        }

        if (typeof linha.hosts === "string") {
          return linha.hosts;
        }

        return "";
      },
    },
    { field: "interface", headerName: "Interface", flex: 0.8 },
    {
      field: "description",
      headerName: "Descrição",
      flex: 1,
      valueFormatter: (params) => params?.replaceAll('"', ""),
    },
    { field: "occurrences", headerName: "Ocorrências", flex: 0.4 },
  ];

  const getOsDetailsForProtocolo = async (protocolo) => {
    setLoadingTicketDetails(true);
    try {
      const response = await api.post(`/interno/ticketDetails/protocolo`, {
        protocolo: protocolo?.trim(),
      });

      setTicketDetails(response?.data);
      setItensPublic((prev) => {
        const mensagens = [];
        const anexos = [];
        const anexosCliente = [];
        const rfo = [];
        for (const item of response?.data?.itensTicketPublic || []) {
          if (item?.itemType === "mensagem") {
            mensagens.push(item?.itemId);
          } else if (item?.itemType === "anexo") {
            anexos?.push(item?.itemId);
          } else if (item?.itemType === "anexoCliente") {
            anexosCliente?.push(item?.itemId);
          } else if (item?.itemType === "rfo") {
            rfo?.push(item?.itemId);
          }
        }

        return {
          ...prev,
          mensagens,
          anexos,
          anexosCliente,
          rfo,
        };
      });
    } catch (error) {
      setTicketDetails(null);
      console.log(error);
      setSnackbar({
        children: "Protocolo não encontrado",
        severity: "warning",
      });
    } finally {
      setLoadingTicketDetails(false);
    }
  };

  const columnsAtendimentos = [
    {
      field: "cliente",
      headerName: "Cliente",
      minWidth: 250,
      flex: 1.5,
      // O campo segue sendo `cliente`, então ordenação e busca do datagrid
      // continuam operando sobre o nome cru.
      renderCell: (params) => (
        <ClienteComTipo
          nome={params?.value}
          tipoCliente={params?.row?.tipoCliente}
        />
      ),
    },
    {
      field: "serviceID",
      headerName: "Serviço ID",
      minWidth: 90,
      flex: 0.5,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 80,
      flex: 0.5,
      renderCell: (params) => {
        return chipStatusAtendimento(params.value);
      },
    },
    {
      field: "dataAbertura",
      headerName: "Abertura",
      type: "dateTime",
      minWidth: 100,
      flex: 0.7,
      valueGetter: (value) => (value ? new Date(value) : null),
      valueFormatter: (value) =>
        value ? dayjs(value).format("DD/MM HH:mm") : "",
    },
    {
      field: "dataFechamento",
      headerName: "Finalização",
      type: "dateTime",
      minWidth: 100,
      flex: 0.7,
      valueGetter: (value) => (value ? new Date(value) : null),
      valueFormatter: (value) =>
        value ? dayjs(value).format("DD/MM HH:mm") : "",
    },

    {
      field: "protocolo",
      headerName: "Atendimento",
      minWidth: 110,
      flex: 0.4,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) =>
        params?.value ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <Tooltip title={`Protocolo: ${params?.value}`} arrow>
              <IconButton
                size="small"
                onClick={() => {
                  setOpenModal(true);
                  getOsDetailsForProtocolo(params?.value);
                }}
              >
                <Badge
                  color="error"
                  badgeContent={Number(params?.row?.quantidadeOS) || 0}
                  invisible={Number(params?.row?.quantidadeOS) < 1}
                  overlap="circular"
                  sx={{
                    "& .MuiBadge-badge": {
                      fontSize: "0.6rem",
                      height: "16px",
                      minWidth: "16px",
                    },
                  }}
                >
                  <Article fontSize="small" />
                </Badge>
              </IconButton>
            </Tooltip>
          </Box>
        ) : null,
    },
  ];

  async function gerarPdfAutoTable() {
    // PEGAR AS LINHAS EXATAMENTE COMO ESTÃO NO DATAGRID
    const sortedIds = apiRefAlerts.current.getSortedRowIds();
    const orderedRowsRaw = sortedIds.map(
      (id) => apiRefAlerts.current.getRow(id), // Obtem as linhas do grid
    );

    // MONTAR AS LINHAS DO PDF COM BASE NA ORDEM DO GRID
    const rows = orderedRowsRaw?.map((alert) => [
      alert?.nome || "",
      alert?.hosts?.[0]?.host || "",
      alert?.interface || "",
      alert?.description?.replaceAll('"', "") || "",
      alert?.occurrences?.toString() || "0",
    ]);

    const headers = [
      ["Cliente", "Host", "Interface", "Descrição", "Ocorrências"],
    ];

    const title = "alertas - recorrentes.pdf";

    try {
      await generatePdfTable({
        setLoadingPdf,
        api,
        rows,
        headers,
        theme,
        title,
      });
    } catch (error) {
      setSnackbar({
        children: `Error:${error.message || "Erro ao gerar PDF"} `,
        severity: "error",
      });
    }
  }

  const animatedTabPanelSx = (isActive, offset = 1) => ({
    ...styles.animatedTabPanel,
    opacity: isActive ? 1 : 0,
    visibility: isActive ? "visible" : "hidden",
    pointerEvents: isActive ? "auto" : "none",
    transform: isActive ? "translateX(0)" : `translateX(${offset * 12}px)`,
  });

  return (
    <Box sx={styles.container}>
      <TopBarFilter
        actions={actions}
        selectorComponentLeft={selectorComponentLeft}
        selectorComponentRight={selectorComponentRight}
        windowWidth={windowWith}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        type={1}
      />
      <Box sx={styles.content}>
        {/** C A R D S */}
        <Grid container spacing={1} columns={12}>
          {cardParams?.map((card) => (
            <Grid item xs={12} sm={6} md={4} lg={4} xl={2} key={card?.name}>
              <CardDataComponent
                cardTile={card?.name}
                cardValue={cardData?.[card?.key] || 0}
                typeIcon={card?.typeIcon}
                colorCard={card?.color}
                loading={card?.loading}
                helperText={card?.helperText}
                info={card?.info}
              />
            </Grid>
          ))}
        </Grid>

        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid container spacing={1}>
              {/** C O L U N A   E S Q U E R D A  —  C L I E N T E S */}
              <Grid item xs={12} md={6}>
                <TabsErp
                  value={tabValue}
                  onChange={handleTabChange}
                  cpeCount={rankingPercentil?.length}
                  onuCount={resumoOnu?.length}
                  loadingCpe={loading}
                  loadingOnu={loadingOnu}
                />
                <Box sx={styles.animatedTabFrame}>
                  <Box
                    aria-hidden={tabValue !== 0}
                    sx={animatedTabPanelSx(tabValue === 0, -1)}
                  >
                    <TabCPE
                      filteredRows={filteredRows}
                      loading={loading}
                      initial_date={initial_date}
                      formatUptime={formatUptime}
                      setSelectedRow={setSelectedRowCpe}
                    />
                  </Box>

                  <Box
                    aria-hidden={tabValue !== 1}
                    sx={animatedTabPanelSx(tabValue === 1)}
                  >
                    <TabOnu
                      filteredRows={filteredRowsOnu}
                      loading={loadingOnu}
                      setSelectedRow={setSelectedRowOnu}
                    />
                  </Box>
                </Box>
              </Grid>

              {/** C O L U N A   D I R E I T A  —  A T E N D I M E N T O S  /  D E T A L H E */}
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <Tabs
                    value={viewDireita}
                    onChange={(event, newValue) => setViewDireita(newValue)}
                    sx={styles.tabs}
                  >
                    <Tab
                      label={<Box sx={styles.boxTab}>Atendimentos</Box>}
                      sx={styles.boxTab}
                    />
                    <Tab
                      label={
                        tabValue === 0 ? (
                          <Box sx={styles.boxTab}>Tráfego</Box>
                        ) : (
                          <Box sx={styles.boxTab}>Potência</Box>
                        )
                      }
                    />
                  </Tabs>

                  <Box sx={styles.animatedTabFrame}>
                    {/* Atendimentos (aba 0) — compartilhada entre CPE e ONU */}
                    <Box
                      aria-hidden={viewDireita !== 0}
                      sx={animatedTabPanelSx(viewDireita === 0, -1)}
                    >
                      <TabAtendimentos
                        rowsAtendimentos={filteredAtendimentos}
                        columnsAtendimentos={columnsAtendimentos}
                        loadingAtendimentos={loadingAtendimentos}
                      />
                    </Box>

                    {/* Detalhe (aba 1) — Tráfego (CPE) */}
                    <Box
                      aria-hidden={viewDireita !== 1 || tabValue !== 0}
                      sx={{
                        ...animatedTabPanelSx(
                          viewDireita === 1 && tabValue === 0,
                        ),
                        flexDirection: "column",
                      }}
                    >
                      <TabTrafego
                        selectedRow={selectedRowCpe}
                        initial_date={initial_date}
                        final_date={final_date}
                        controllerDashboard={controllerDashboard}
                        setControllerDashboard={setControllerDashboard}
                        setSnackbar={setSnackbar}
                      />
                    </Box>

                    {/* Detalhe (aba 1) — Potência (ONU) */}
                    <Box
                      aria-hidden={viewDireita !== 1 || tabValue !== 1}
                      sx={{
                        ...animatedTabPanelSx(
                          viewDireita === 1 && tabValue === 1,
                        ),
                        flexDirection: "column",
                      }}
                    >
                      <TabPotencia
                        selectedRow={selectedRowOnu}
                        initial_date={initial_date}
                        final_date={final_date}
                        labelErp={labelErp}
                      />
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>

          {/** A L E R T A S    R E C O R R E N T E S */}

          <Grid item xs={12}>
            <Paper
              sx={styles.paperRecurringAlerts}
              elevation={theme.palette.mode == "dark" ? 0 : 3}
            >
              {loadingReccurringAlerts && (
                <LinearProgress sx={styles.linearProgress} />
              )}
              <Box sx={styles.containerHeaderRecurringAlerts}>
                <Typography variant="h6" sx={styles.gridTitle}>
                  Alertas - Recorrentes
                </Typography>
                <Box sx={styles.boxRecurringAlertsSearchePrintFields}>
                  {/* Campos de busca do Alerta mantidos aqui */}
                  <TextField
                    variant="outlined"
                    label="Buscar alertas"
                    size="small"
                    sx={styles.recurringAlertSearchField}
                    value={searchAlert || ""}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search />
                        </InputAdornment>
                      ),
                      endAdornment: searchAlert ? (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setSearchAlert("")}
                            edge="end"
                            size="small"
                          >
                            <Clear />
                          </IconButton>
                        </InputAdornment>
                      ) : null,
                    }}
                    onChange={(event) => setSearchAlert(event.target.value)}
                    disabled={
                      !filteredAlerts?.length ||
                      !!loadingPdf ||
                      !!loadingReccurringAlerts
                    }
                  />
                  <IconButton
                    size="small"
                    onClick={() => gerarPdfAutoTable()}
                    disabled={
                      !filteredAlerts?.length ||
                      !!loadingPdf ||
                      !!loadingReccurringAlerts
                    }
                  >
                    <Print
                      sx={
                        !filteredAlerts?.length ||
                        loadingPdf ||
                        loadingReccurringAlerts
                          ? { color: theme.palette.colors.gray.light }
                          : styles.recurringAlertPrintIcon
                      }
                    />
                  </IconButton>
                </Box>
              </Box>
              <Divider />
              <Box sx={styles.containerDataGrid}>
                <DatagridComponent
                  loading={loadingReccurringAlerts}
                  columns={recurringAlertsColumns}
                  rows={filteredAlerts || []}
                  isPagination={false}
                  apiRef={apiRefAlerts}
                />
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>

      <>
        {erp !== "IXC" ? (
          // Componente refatorado (agora é um Drawer e gerencia o modal de saída internamente)
          <TicketModalContent
            open={openModal} // <- Passando a prop para controlar o Drawer internamente
            loading={loadingTicketDetails}
            handleClose={handleCloseSearch} // <- Função limpa, sem validações no pai
            erp={erp}
            ticketDetails={ticketDetails}
            status={ticketDetails?.status}
            labelTabsErp={labelTabsErp}
            value={ticketTabValue}
            handleChange={handleTicketTabChange}
            isEdit={true}
            setTicketDetails={setTicketDetails}
            itensPublic={itensPublic}
            setItensPublic={setItensPublic}
            setSnackbar={setSnackbar}
            setIsEditTicket={setIsEditTicket}
            isEditTicket={isEditTicket}
            setIsFinishTicket={setIsFinishTicket}
            isFinishTicket={isFinishTicket}
            isEditOs={isEditOs}
            setIsEditOs={setIsEditOs}
            setIsNewOs={setIsNewOs}
            isNewOs={isNewOs}
          />
        ) : (
          // Modal mantido para o IXC e para o estado de loading

          <>
            {erp === "IXC" ? (
              <>
                <TicketModalContentIxc
                  open={openModal}
                  handleClose={handleCloseSearch}
                  loading={loadingTicketDetails}
                  erp={erp}
                  ticketDetails={ticketDetails}
                  status={ticketDetails?.status}
                  labelTabsErp={labelTabsErp}
                  value={ticketTabValue}
                  handleChange={handleTicketTabChange}
                  isEdit={true}
                  setTicketDetails={setTicketDetails}
                  itensPublic={itensPublic}
                  setItensPublic={setItensPublic}
                  setSnackbar={setSnackbar}
                  setIsEditTicket={setIsEditTicket}
                  isEditTicket={isEditTicket}
                  setIsFinishTicket={setIsFinishTicket}
                  isFinishTicket={isFinishTicket}
                  isEditOs={isEditOs}
                  setIsEditOs={setIsEditOs}
                  setIsNewOs={setIsNewOs}
                  isNewOs={isNewOs}
                />

                <InternoModalConfirmacaoSaida
                  openConfirmacao={confirmacaoSaidaPagina}
                  confirmLoad={false}
                  setOpenConfirmacao={setConfirmacaoSaidaPagina}
                  execute={handleCloseSearch}
                  cancel={handleCancelNavigation}
                  severity={"warning"}
                  title={"Atenção"}
                  contentText={
                    "As alterações não salvas serão perdidas, deseja continuar?"
                  }
                  headerText={"Você está prestes a sair do modo de edição."}
                  confirmText={"Continuar"}
                />
              </>
            ) : (
              <Box sx={styles.boxModal}>
                <Box sx={styles.boxCicularProgress}>
                  <CircularProgress />
                </Box>
              </Box>
            )}
          </>
        )}
      </>

      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </Box>
  );
}

const formatBytes = (bytes) => {
  if (bytes == 0) return "0 B";
  const k = 1000;
  const sizes = ["bps", "Kbps", "Mbps", "Gbps", "Tbps", "Pbps", "Ebps"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};
